import 'babel-polyfill';

import './assets/stylesheets/index.scss';

import translate from 'counterpart';
import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { Provider } from 'react-redux';
import { applyRouterMiddleware, browserHistory, Router } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import { useScroll } from 'react-router-scroll';
import { applyMiddleware, createStore, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import * as storage from 'redux-storage';

import middleware from './middleware';
import reducers from './reducers';
import routes from './config/routes';
import rootSaga from './sagas';
import storageEngine from './lib/storageEngine';
import ReduxToastr from 'react-redux-toastr';
import ReactGA from 'react-ga';

translate.registerTranslations('en', require('./config/locales/en').default);

const sagaMiddleware = createSagaMiddleware();

middleware.push(sagaMiddleware);
ReactGA.initialize(process.env.GA_API_KEY);
ReactGA.pageview(window.location.pathname + window.location.search);

const load           = storage.createLoader(storageEngine);
const store          = compose(applyMiddleware.apply(this, middleware))(createStore)(reducers, window.devToolsExtension && window.devToolsExtension());
const history        = syncHistoryWithStore(browserHistory, store, {
  selectLocationState(state) {
    return state.get('routing').toObject();
  }
});

history.listen(function(location) {
  ReactGA.pageview(location.pathname + location.search);
});

sagaMiddleware.run(rootSaga);

load(store).then(() => {
  const root = (
    <AppContainer>
      <Provider store={ store }>
        <React.Fragment>
          <Router history={ history } render={ applyRouterMiddleware(useScroll()) }>
            { routes() }
          </Router>
          <ReduxToastr newestOnTop={ false }
            position='top-right'
            preventDuplicates
            progressBar
            timeOut={ 4000 }
            transitionIn='fadeIn'
            transitionOut='fadeOut' />
        </React.Fragment>
      </Provider>
    </AppContainer>
  );

  ReactDOM.render(root, document.getElementById('body'));
});



// WEBPACK FOOTER //
// ./app/index.jsx